import React from 'react'
import { usePortal } from '../hooks/usePortal'
import Breadcrumbs from '../components/Breadcrumbs'
import { createPortal } from 'react-dom'
import Articles from '../components/Articles'
import getArticles from '../api/getArticles'
import ArticleCard from '../components/ArticleCard'
import { ArticleData } from '../server/utils/getArticlesData'
import { axiosInstance } from '../hooks/useAxios'
import { addArticleToFavorite } from '../api/addArticleToFavorite'
import { removeArticleFromFavorite } from '../api/removeArticleFromFavorite'
import Person from '../components/Person'

const CommunitiesPage: React.FC<any> = () => {
  const BREADCRUMBS = [
    {
      label: 'Главная',
      path: '/'
    },
    {
      label: 'Сообщества',
      path: '/communities'
    }
  ]
  const { portal } = usePortal()

  const favoriteHandler = async (value: boolean, id: string) => {
    if (value) {
      await axiosInstance(addArticleToFavorite('communities', id))
    } else {
      await axiosInstance(removeArticleFromFavorite('communities', id))
    }
  }

  return (
    <div className={'page'}>
      <Breadcrumbs className={'page__breadcrumbs'} breadcrumbs={BREADCRUMBS} />
      {portal &&
        createPortal(
          <Breadcrumbs breadcrumbs={BREADCRUMBS}></Breadcrumbs>,
          portal
        )}

      <header className="page__head">
        <h1>Сообщества</h1>
      </header>

      <div className="page__content">
        <Articles
          search
          tabsNavigation
          queryMode
          count={9}
          method={(options: any) => getArticles('/communities/list', options)}
          renderContent={({ items }, loading, updateSections) => {
            return loading || items.length ? (
              <div className={'app-grid _columns-3-1'}>
                {loading
                  ? Array.from({ length: 9 }).map((_, index) => (
                      <ArticleCard key={index} loading></ArticleCard>
                    ))
                  : items.map((item: ArticleData) => (
                      <ArticleCard
                        favoriteHandler={async (value) => {
                          await favoriteHandler(value, item.id as string)
                          await updateSections()
                        }}
                        key={item.id}
                        tags={item.tags}
                        title={item.title}
                        favorite={item.favorite}
                        picture={item.previewPicture}
                        to={`/communities/${item.id}`}
                        renderFoot={
                          item.chief
                            ? () => (
                                <Person
                                  avatarUrl={item.chief?.avatarUrl}
                                  name={item.chief?.name ?? ''}
                                  role={item.chief?.role}
                                ></Person>
                              )
                            : undefined
                        }
                      ></ArticleCard>
                    ))}
              </div>
            ) : (
              'Нет данных'
            )
          }}
        ></Articles>
      </div>
    </div>
  )
}

export default CommunitiesPage
